import BookShow from "components/shared/book/show";
import InlineBtn from "components/shared/inlineBtn";
import { mobileAppTypes } from "helpers/enums";
import { HiddenDataWrapper } from "helpers/hiddenData";
import { viewContainer } from "helpers/redux";
import { enumLabel } from "helpers/system";
import policy from "policies";
import React from "react";
import { applyDriverFuelCards } from "sources/books/fuelCards";
import { config, initialState } from "../formConfig";
import DriverLicenseData from "./driverLicenseData";
import DriverPassportData from "./driverPassportData";
import Markup from "./markup";

class ShowDriver extends BookShow {
    actionPrint = () => {
        const { modal } = this.props;
        return modal({
            name: "print",
            title: "Печать водителя",
            CustomBody: () => this.renderBody(),
        });
    };

    linkFuelCards = () => {
        this.props.modal({
            name: "linkFuelCards",
            title: "Привязка топливных карт к водителю",
            windowMod: "wide",
            data: { driverId: this.state.data.id },
            linkedCardIds: this.state.data.fuelCards.map((item) => item.id),
            linkCards: applyDriverFuelCards,
            callback: () => this.getItem(this.props),
        });
    };

    renderFuelCards = () => {
        const { profile, roles, refuelingSettings } = this.props;
        if (!policy("user", { user: { profile, roles }, options: { refuelingSettings } }).isFuelLimitEnabled()) {
            return null;
        }
        return (
            <div className="row pb-3">
                <label className="col-12 col-form-label col-form-label-sm text-muted">Топливные карты</label>
                <div className="col-12">
                    {this.state.data.fuelCards.map((card) => (
                        <span key={card.id} className="mr-2 badge badge-pill badge-primary">
                            {card.number}
                        </span>
                    ))}
                    <div className="mt-2">
                        <InlineBtn value="Привязать топливные карты" action={this.linkFuelCards} cname="plus" />
                    </div>
                </div>
            </div>
        );
    };

    renderDeviceInfo = () => {
        const { deviceInfo } = this.state.data;
        if (!deviceInfo) {
            return null;
        }
        return (
            <div className="row pb-3">
                <label className="col-12 col-form-label col-form-label-sm text-muted">Информация об устройстве</label>
                <div className="col-12 pt-1">
                    <table className="table table-sm w-auto">
                        <tbody>
                            <tr>
                                <td>
                                    <b>Тип приложения</b>
                                </td>
                                <td>{enumLabel(mobileAppTypes, deviceInfo.appType)}</td>
                            </tr>
                            <tr>
                                <td>
                                    <b>Версия приложения</b>
                                </td>
                                <td>{deviceInfo.appVersion}</td>
                            </tr>
                            <tr>
                                <td>
                                    <b>Модель телефона</b>
                                </td>
                                <td>{deviceInfo.model}</td>
                            </tr>
                            <tr>
                                <td>
                                    <b>Тип ОС</b>
                                </td>
                                <td>{deviceInfo.osType}</td>
                            </tr>
                            <tr>
                                <td>
                                    <b>Версия ОС</b>
                                </td>
                                <td>{deviceInfo.osVersion}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };

    renderBody = () => {
        const { config, roles } = this.props;
        return (
            <div className="row">
                <div className="col-sm-6 mb-3">
                    <div className="card card-body">
                        <Markup
                            {...config}
                            renderField={this.renderField}
                            renderFuelCards={this.renderFuelCards}
                            Button={this.renderButton}
                            renderCheckbox={this.renderCheckbox}
                            renderSelect={this.renderSelect}
                            renderDeviceInfo={this.renderDeviceInfo}
                        />
                    </div>
                </div>
                {!roles.isTruckingOrganizationExtendedViewer && (
                    <div className="col-sm-6">
                        <HiddenDataWrapper>
                            <DriverPassportData id={this.props.match.params.id} modal={this.props.modal} />
                            <DriverLicenseData id={this.props.match.params.id} modal={this.props.modal} />
                        </HiddenDataWrapper>
                    </div>
                )}
            </div>
        );
    };
}

const ConfiguredShow = (props) => <ShowDriver {...props} config={config} initialState={initialState} />;

export default viewContainer(ConfiguredShow, "drivers");
